import { render, staticRenderFns } from "./ProductBulletpoints.vue?vue&type=template&id=5232c912&"
import script from "./ProductBulletpoints.vue?vue&type=script&lang=js&"
export * from "./ProductBulletpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports